import {
  QUICK_START_BASE,
  QUICK_START_DOCUMENTS,
  QUICK_START_INFO,
  QUICK_START_CONTRACT,
} from '@app/Seller/QuickStart/accessTokens'

import {
  PRODUCTS_LIST,
  PRODUCTS_INFO,
  PRODUCTS_VALIDATION,
  PRODUCTS_ADD,
} from '@app/Seller/Products/accessTokens'

import {
  BALANCE_BASE,
  BALANCE_PAYMENTS_LIST,
  BALANCE_LIST,
  BALANCE_LIQPAY_SUCCESS,
} from '@app/Seller/Balance/accessTokens'

import {
  IMPORTER_VALIDATION,
} from '@app/Seller/Importer/accessTokens'

import {
  ALL,
  SETTINGS_TOKEN,
  BLOCKED_TOKEN,
} from '@app/Seller/accessTokens'

const NEW_SHOP = {
  QUICK_START_BASE,
  QUICK_START_INFO,
}
const CAN_ADD_DOCS = {
  QUICK_START_DOCUMENTS,
}
const WAITING_FOR_CONTRACT = {
  QUICK_START_CONTRACT,
}
const VERIFIED = {
  PRODUCTS_LIST,
  PRODUCTS_INFO,
  PRODUCTS_VALIDATION,
  PRODUCTS_ADD,
  IMPORTER_VALIDATION,
  BALANCE_BASE,
  BALANCE_PAYMENTS_LIST,
  BALANCE_LIST,
  BALANCE_LIQPAY_SUCCESS,
}
const FOR_ALL_STATUSES = {
  ...WAITING_FOR_CONTRACT,
  ...VERIFIED,
  SETTINGS_TOKEN,
  ALL,
}

const BLOCKED_STATUSES = {
  BLOCKED_TOKEN,
}

export const SHOP_STATUS_NEW = 'new'
export const SHOP_STATUS_REQUIRES_VERIFICATION = 'requires_verification'
export const SHOP_STATUS_WAITING_SIGNING_CONTRACT = 'wait_signing_contract'
export const SHOP_STATUS_VERIRIED = 'verified'
export const SHOP_STATUS_ACTIVE = 'active'
export const SHOP_STATUS_BLOCKED = 'blocked'
export const SHOP_STATUS_PROBLEM = 'problem'
export const SHOP_STATUS_SUSPENDED = 'suspended'
export const SHOP_STATUS_DISABLED = 'disabled'

export const SHOP_STATUS_CHOICES = {
  [SHOP_STATUS_NEW]: {
    ...NEW_SHOP,
  },
  [SHOP_STATUS_REQUIRES_VERIFICATION]: {
    ...NEW_SHOP,
    ...CAN_ADD_DOCS,
  },
  [SHOP_STATUS_WAITING_SIGNING_CONTRACT]: {
    ...NEW_SHOP,
    ...CAN_ADD_DOCS,
    ...WAITING_FOR_CONTRACT,
  },
  [SHOP_STATUS_VERIRIED]: {
    // ...NEW_SHOP,
    // ...CAN_ADD_DOCS,
    // ...WAITING_FOR_CONTRACT,
    ...VERIFIED,
    SETTINGS_TOKEN,
  },
  [SHOP_STATUS_ACTIVE]: {
    ...FOR_ALL_STATUSES,
  },
  [SHOP_STATUS_BLOCKED]: {
    ...BLOCKED_STATUSES,
  },
  [SHOP_STATUS_PROBLEM]: {
    ...BLOCKED_STATUSES,
  },
  [SHOP_STATUS_SUSPENDED]: {
    ...BLOCKED_STATUSES,
  },
  [SHOP_STATUS_DISABLED]: {
    ...BLOCKED_STATUSES,
  },
}
window.SHOP_STATUS_CHOICES = SHOP_STATUS_CHOICES
